export const UPLOADING_FILE_TO_GOOGLE_DRIVE = 'UPLOADING_FILE_TO_GOOGLE_DRIVE';
export const FILE_TERMINATE_LOADING = 'FILE_TERMINATE_LOADING';
export const FILE_ERROR_UPLOADED = 'FILE_ERROR_UPLOADED';

export function uploadFileToGoogleDrive(customerFiles) {
  return {
    type: UPLOADING_FILE_TO_GOOGLE_DRIVE,
    customerFiles,
  };
}

export function fileTerminateUpload(file) {
  return {
    type: FILE_TERMINATE_LOADING,
    file,
  };
}

export function fileErrorUploaded() {
  return {
    type: FILE_ERROR_UPLOADED,
  };
}



// WEBPACK FOOTER //
// ./src/services/DriveService/actions.js